import { FC, useRef } from 'react'
import { Link } from 'react-router-dom'
import clsx from 'clsx'
import { AsideMenu } from './AsideMenu'
import { useLayout } from '../layout/core/LayoutProvider'
import { toAbsoluteUrl } from '../../utils/toAbsolutePath'
import { KTSVG } from '../helpers/components'
import { useLogout } from '../../hooks/useLogout'

/**
 * Sidebar principal: logo Veolia, menu de navegacion (AsideMenu) y boton de cerrar sesion.
 * Soporta minimizar/expandir via toggle. En mobile se comporta como drawer.
 */
const AsideDefault: FC = () => {
  const { config, classes } = useLayout()
  const asideRef = useRef<HTMLDivElement | null>(null)
  const { aside } = config
  const { logout } = useLogout()

  const minimize = () => {
    asideRef.current?.classList.add('animating')
    setTimeout(() => {
      asideRef.current?.classList.remove('animating')
    }, 300)
  }

  return (
    <div
      id='kt_aside'
      className={clsx('aside', classes.aside.join(' '))}
      data-kt-drawer='true'
      data-kt-drawer-activate='{default: true, lg: false}'
      data-kt-drawer-direction='start'
      data-kt-drawer-toggle='#kt_aside_mobile_toggle'
      ref={asideRef}>
      {/* begin::Brand */}
      <div className='aside-logo flex-column-auto' id='kt_aside_logo'>
        {/* begin::Logo */}
        {aside.theme === 'light' && (
          <Link to='/dashboard'>
            <img
              alt='Logo'
              className='h-45px logo'
              src={toAbsoluteUrl('/media/logos/veolia-logo.png')}
            />
          </Link>
        )}
        {/* end::Logo */}

        {/* begin::Aside toggler */}
        {aside.minimize && (
          <div
            id='kt_aside_toggle'
            className='btn btn-icon w-auto px-0 btn-active-color-primary aside-toggle'
            data-kt-toggle='true'
            data-kt-toggle-state='active'
            data-kt-toggle-target='body'
            data-kt-toggle-name='aside-minimize'
            onClick={minimize}>
            <KTSVG
              path={'/media/icons/duotune/arrows/arr079.svg'}
              className={'svg-icon-1 rotate-180'}
            />
          </div>
        )}
        {/* end::Aside toggler */}
      </div>
      {/* end::Brand */}
      {/* begin::Aside menu */}
      <div className='aside-menu flex-column-fluid'>
        <AsideMenu asideMenuCSSClasses={classes.asideMenu} />
      </div>
      {/* end::Aside menu */}
      {/* begin::Footer */}
      <div className='aside-footer flex-column-auto pt-5 pb-7 px-5' id='kt_aside_footer'>
        <a target='_blank' className='btn btn-custom btn-primary w-100' onClick={logout}>
          <span className='btn-label'>Cerrar sesión</span>
          <span className='svg-icon btn-icon svg-icon-2'>
            <KTSVG path='/svg/sign-out.svg' />
          </span>
        </a>
      </div>
      {/* end::Footer */}
    </div>
  )
}

export { AsideDefault }
